// SPDX-License-Identifier: AGPL-3.0-or-later

import type {IconProps} from '@phosphor-icons/react';
import React from 'react';
export const LockedTextChannelIcon = React.forwardRef<SVGSVGElement, IconProps>(
	({size = 256, className, ...props}, ref) => (
		<svg
			ref={ref}
			width={size}
			height={size}
			viewBox="0 0 256 256"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			aria-hidden={true}
			{...props}
		>
			<path
				fill="currentColor"
				d="M100.193 37.8534c1.186-6.5204 7.433-10.8456 13.953-9.6602 6.521 1.1855 10.846 7.4327 9.661 13.9531l-7.61 41.8535H144V108h-32.167l-7.272 40h39.606l4.545-25h24.393l-4.544 25H208c6.627 0 12 5.372 12 12 0 6.627-5.373 12-12 12h-43.803l-8.39 46.146c-1.186 6.521-7.433 10.846-13.953 9.66-6.521-1.185-10.846-7.432-9.661-13.953l7.61-41.853h-39.606l-8.3904 46.146c-1.1855 6.521-7.4326 10.846-13.9531 9.66-6.5204-1.185-10.8456-7.432-9.6601-13.953L75.8027 172H32c-6.6274 0-12-5.373-12-12 .0001-6.628 5.3726-12 12-12h48.167l7.2725-40H48c-6.6274 0-12-5.373-12-12.0002.0001-6.6273 5.3726-12 12-12h43.8027z"
			/>
			<path
				fill="currentColor"
				d="M234.25 50.25h-12.5v-9.375c0-4.9728-1.975-9.7419-5.492-13.2583-3.516-3.5163-8.285-5.4917-13.258-5.4917s-9.742 1.9754-13.258 5.4917c-3.517 3.5164-5.492 8.2855-5.492 13.2583v9.375h-12.5c-1.658 0-3.247.6585-4.419 1.8306-1.173 1.1721-1.831 2.7618-1.831 4.4194v43.75c0 1.658.658 3.247 1.831 4.419 1.172 1.173 2.761 1.831 4.419 1.831h62.5c1.658 0 3.247-.658 4.419-1.831 1.173-1.172 1.831-2.761 1.831-4.419V56.5c0-1.6576-.658-3.2473-1.831-4.4194-1.172-1.1721-2.761-1.8306-4.419-1.8306M203 83.0625c-.927 0-1.833-.2749-2.604-.79s-1.372-1.2472-1.727-2.1037c-.354-.8565-.447-1.799-.266-2.7083.18-.9093.627-1.7445 1.282-2.4001.656-.6555 1.491-1.102 2.401-1.2828.909-.1809 1.851-.0881 2.708.2667.856.3548 1.588.9556 2.104 1.7265.515.7708.79 1.6771.79 2.6042 0 1.2432-.494 2.4355-1.373 3.3146-.88.879-2.072 1.3729-3.315 1.3729M215.5 50.25h-25v-9.375c0-3.3152 1.317-6.4946 3.661-8.8388s5.524-3.6612 8.839-3.6612 6.495 1.317 8.839 3.6612 3.661 5.5236 3.661 8.8388z"
			/>
		</svg>
	),
);
